// Dependencies
import {
  USUARIOS_REQUEST,
  USUARIOS_REFRESH,
  USUARIOS_OK,
  USUARIOS_ERROR,
} from "./types";

const initialState = {
  qty: null,
  data: [],
  loading: false,
  error: false,
  refreshing: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USUARIOS_REQUEST:
      return { ...state, loading: true };
    case USUARIOS_REFRESH:
      return { ...state, refreshing: true };
    case USUARIOS_ERROR:
      return {
        ...state,
        refreshing: false,
        loading: false,
        error: action.payload.error,
      };
    case USUARIOS_OK:
      return {
        ...state,
        refreshing: false,
        loading: false,
        data: action.payload.data,
        qty: action.payload.qty,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
